import { AppointmentPhase } from "components";
import PanelSegment from "components/panels/PanelSegment/PanelSegment";
import SectionPanel from "components/panels/SectionPanel/SectionPanel";
import { ExternalEventSidePanel } from "components/SidePanel/ExternalEvent/ExternalEventSidePanel";
import Table from "components/Tables/Table";
import React, { useState } from "react";
import ShowDateTime from "show/components/ShowDateTime";
import { useCustomQuery, useManualPagination } from "utilities/hookutils";

interface Props {
  externalCalendarId: number;
}

export const ExternalEventsPanel = (props: Props) => {
  const perPage = 10;
  const [total, setTotal] = React.useState<number>(0);
  const [instruction, setInstruction] = useState<server.dto.PaginatedExternalEventInstruction>({
    page: 1,
    perPage,
    externalCalendarIds: [props.externalCalendarId],
  });

  const api = useCustomQuery({
    queryFn: () => window.CoreApi.ExternalEvent.Paginated(instruction),
    queryKey: ["externalEvents", instruction],
    onSuccess: (response) => {
      setTotal(response.data.pagination.total);
      pagination.setPagination(response.data.pagination);
    }
  });

  const paginate = (paginationData: Partial<server.dto.PaginationData>) => {
    setInstruction({
      ...instruction,
      page: paginationData.page,
      perPage: paginationData.perPage
    });
  };

  const pagination = useManualPagination(instruction.page || 1, perPage, paginate);
  const items = api.data?.data?.data || [];
  const isLoading = api.isLoading;

  return <SectionPanel.Panel
    header={<>
      <PanelSegment.Title title={`${RESX.ExternalCalendar.ExternalEvents}: ${total}`} />
      {pagination && <PanelSegment.Pagination>{pagination.Component}</PanelSegment.Pagination>}
    </>}
  >
    <Table
      items={items}
      isLoading={isLoading}
      getKey={event => event.externalEventId.toString()}
      hideHeader
      columns={[{
        key: "dateAndTime",
        header: "",
        render: (event) => <ShowDateTime dateTime={event.dateTime} />,
      }, {
        key: "title",
        header: "",
        render: (event) => <div className="flex gap">
          <AppointmentPhase value={event.phase} displayLabel={false} />
          <ExternalEventSidePanel
            externalEventId={event.externalEventId}
            trigger={<a style={{ width: "100%" }}>{event.summary}</a>}
          />
        </div>,
      }, {
        key: "location",
        header: "",
        render: (event) => <div>{event.location}</div>
      }]}
    />
  </SectionPanel.Panel>
}
